import { render, staticRenderFns } from "./AuthorityCreate.vue?vue&type=template&id=c76a4c98&scoped=true&"
import script from "./AuthorityCreate.vue?vue&type=script&lang=js&"
export * from "./AuthorityCreate.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityCreate.vue?vue&type=style&index=0&id=c76a4c98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76a4c98",
  null
  
)

export default component.exports